<template>
  <div class="content4 content5 contentPage swiper-slide" :class="nowPage === 4 ? 'cartoon' : ''">
    <div class="animalNav" :style="{display: showNow === 0 ? 'flex' : 'none'}">
      <div class="leftTxtWrap">
        <img :src="txtImg" class="txtImg"/>
        <div class="heng"></div>
        <img :src="titleImg" class="titleImg"/>
        <div class="txtInfo">
          <p>中国东北地区发现了一系列身披羽毛或似羽皮肤衍生物的恐龙，如中华龙鸟（<em>Sinosauropteryx</em>）、小盗龙（<em>Microraptor</em>）、近鸟龙（<em>Anchiormis</em>）等。它们的骨骼明显是属于恐龙的，但是它们身上却出现了羽毛和类似羽毛的结构，这一发现震惊了科学界，同时也让人们找到了一个鸟类起源于恐龙的有力证据。</p>
          <!-- <p>恐龙和早期鸟类羽毛的类型 Different feather types of dinosaurs and early birds</p>
          <p>鸟类身上结构精巧的羽毛是通过其恐龙祖先一代代遗传和选择而获得的，羽毛的功能也从最初的保暖和炫耀演变成为飞行提供升力。</p>
          <p>恐龙腿上的羽毛最早可能是用来御寒，后来变成真正的飞羽，用于辅助飞行，并一直在早期鸟类中保留，直到鸟类演化的某一阶段，脚上的羽毛才退化，变成了鳞片。</p> -->
        </div>
        <div class="btnWrap">
          <animalBtn 
            v-for="item in btnList" 
            :key="item.id" 
            :cnTitle='item.cnTitle' 
            :enTitle='item.enTitle'
            @click.native="changeShowAnimal(item.id)"
          ></animalBtn>
        </div>
      </div>
      <div class="rightImgWrap">
        <moveImg :imgSrc='rightAni' class="rightAni"></moveImg>
      </div>
    </div>

    <!-- <categoryAnimal 
      :animalType='featheredDinosaurs.animalType' 
      :animalTypeEn='featheredDinosaurs.animalTypeEn'
      :categoryTxt='featheredDinosaurs.categoryTxt'
      :categoryInfoImg='featheredDinosaurs.categoryInfoImg'
      :showList='featheredDinosaurs.showList'
      @changeShowAnimal='changeShowAnimal'
      :show="showNow === 1"
    ></categoryAnimal> -->
    <categoryAnimal 
      :animalType='differentAnimal.animalType' 
      :animalTypeEn='differentAnimal.animalTypeEn'
      :categoryTxt='differentAnimal.categoryTxt'
      :categoryInfoImg='differentAnimal.categoryInfoImg'
      :showList='differentAnimal.showList'
      @changeShowAnimal='changeShowAnimal'
      :show="showNow === 1"
    ></categoryAnimal>

    <categoryAnimal 
      :animalType='anchiornisAnimal.animalType' 
      :animalTypeEn='anchiornisAnimal.animalTypeEn'
      :categoryTxt='anchiornisAnimal.categoryTxt'
      :categoryInfoImg='anchiornisAnimal.categoryInfoImg'
      :showList='anchiornisAnimal.showList'
      @changeShowAnimal='changeShowAnimal'
      :show="showNow === 2"
    ></categoryAnimal>

    <categoryAnimal 
      :animalType='microraptorAnimal.animalType' 
      :animalTypeEn='microraptorAnimal.animalTypeEn'
      :categoryTxt='microraptorAnimal.categoryTxt'
      :categoryInfoImg='microraptorAnimal.categoryInfoImg'
      :showList='microraptorAnimal.showList'
      @changeShowAnimal='changeShowAnimal'
      :show="showNow === 3"
    ></categoryAnimal>

    
  </div>
</template>

<script>
import { swiperMixin } from '@/utils/mixin.js'

import txtImg from '@/assets/img/content5/txtImg.png'
import titleImg from '@/assets/img/content5/titleImg.png'
import rightAni from '@/assets/img/content5/rightAni.png'

import { btnList, featheredDinosaurs, differentAnimal, anchiornisAnimal, microraptorAnimal } from './data'


export default {
  mixins: [swiperMixin],
  data () {
    return {
      txtImg,
      titleImg,
      rightAni,
      showNow: 0, // 当前展示的是第几个
      btnList,
      // featheredDinosaurs,
      differentAnimal,
      anchiornisAnimal,
      microraptorAnimal,
    }
  },
  computed: {
    nowPage () {
      return this.$store.state.nowPage
    }
  },
  watch: {
    nowPage ( nowPage ) {
      if ( nowPage === 4 && this.showNow > 0 ) {
        this.showNow = 0
      }
    }
  },
}
</script>

<style lang="stylus" scoped>
@import '../../stylus/app.styl'
@import '../../stylus/animation.styl'
@import '../content4/content4.styl'
@import './content5.styl'
</style>